const translationKeys = {
  transfers_to_label: 'transfers_to_label',
  transfers_from_label: 'transfers_from_label',
  transfers_amount_label: 'transfers_amount_label',
  transfers_date_label: 'transfers_date_label',
  transfers_transfer_message_label: 'transfers_transfer_message_label',
  transfers_transfer_button_text: 'transfers_transfer_button_text',
  transfers_today: 'transfers_today',
  transfers_three_days: 'transfers_three_days',
  transfers_one_week: 'transfers_one_week',
  transfers_next_month: 'transfers_next_month',
  transfers_header_title: 'transfers_header_title',
  transfers_header_description: 'transfers_header_description',
  transfers_account_placeholder: 'transfers_account_placeholder',
  transfers_amount_placeholder: 'transfers_amount_placeholder',
  transfers_transfer_message_placeholder:
    'transfers_transfer_message_placeholder',
  transfers_account_selector_placeholder:
    'transfers_account_selector_placeholder',
  transfers_feedback_success: 'transfers_feedback_success',
  transfers_feedback_success_subtitle: 'transfers_feedback_success_subtitle',
  transfers_feedback_new_transfer_button_text:
    'transfers_feedback_new_transfer_button_text',
  transfers_feedback_failure: 'transfers_feedback_failure',
  transfers_feedback_failure_subtitle: 'transfers_feedback_failure_subtitle',
  transfers_from_account_validation_required:
    'transfers_from_account_validation_required',
  transfers_to_account_validation_required:
    'transfers_to_account_validation_required',
  transfers_amount_validation_required: 'transfers_amount_validation_required',
  transfers_amount_validation_min_value:
    'transfers_amount_validation_min_value',
  transfers_message_validation_max_length:
    'transfers_message_validation_max_length',
  transfers_date_validation_required: 'transfers_date_validation_required',
  transfers_global_status_title: 'transfers_global_status_title',
  transfers_global_status_goto: 'transfers_global_status_goto',
  transfers_global_status_close: 'transfers_global_status_close',
  transfers_recurring_transfer_title: 'transfers_recurring_transfer_title',
  transfers_recurring_transfer_not_active:
    'transfers_recurring_transfer_not_active',
  transfers_recurring_transfer_active: 'transfers_recurring_transfer_active',
  transfers_header_breadcrumb_homepage: 'transfers_header_breadcrumb_homepage',
  transfers_header_breadcrumb_transfers:
    'transfers_header_breadcrumb_transfers',
  transfers_feedback_navigate_to_account_list_button_text:
    'transfers_feedback_navigate_to_account_list_button_text',
  transfers_feedback_navigate_to_pending_payments_button_text:
    'transfers_feedback_navigate_to_pending_payments_button_text',
  transfers_feedback_summary_from_account_title:
    'transfers_feedback_summary_from_account_title',
  transfers_feedback_summary_from_account_new_balance:
    'transfers_feedback_summary_from_account_new_balance',
  transfers_feedback_summary_to_account_title:
    'transfers_feedback_summary_to_account_title',
  transfers_feedback_summary_to_account_new_balance:
    'transfers_feedback_summary_to_account_new_balance',
  transfers_feedback_summary_amount_title:
    'transfers_feedback_summary_amount_title',
  transfers_feedback_summary_message_title:
    'transfers_feedback_summary_message_title',
  transfers_feedback_summary_date_title:
    'transfers_feedback_summary_date_title',
  transfers_feedback_summary_date_invalid:
    'transfers_feedback_summary_date_invalid',
  transfers_feedback_summary_title: 'transfers_feedback_summary_title',
  transfers_balance_negative_balance: 'transfers_balance_negative_balance',
  transfers_balance_insufficient_balance:
    'transfers_balance_insufficient_balance',
  transfers_recurring_button_text: 'transfers_recurring_button_text',
  transfers_recurring_valid_until_date_label:
    'transfers_recurring_valid_until_date_label',
  transfers_recurring_frequency_annually:
    'transfers_recurring_frequency_annually',
  transfers_recurring_frequency_bi_monthly:
    'transfers_recurring_frequency_bi_monthly',
  transfers_recurring_frequency_daily: 'transfers_recurring_frequency_daily',
  transfers_recurring_frequency_fortnightly:
    'transfers_recurring_frequency_fortnightly',
  transfers_recurring_frequency_label: 'transfers_recurring_frequency_label',
  transfers_recurring_frequency_monthly:
    'transfers_recurring_frequency_monthly',
  transfers_recurring_frequency_quarterly:
    'transfers_recurring_frequency_quarterly',
  transfers_recurring_frequency_semi_annually:
    'transfers_recurring_frequency_semi_annually',
  transfers_recurring_frequency_semi_monthly:
    'transfers_recurring_frequency_semi_monthly',
  transfers_recurring_frequency_weekly: 'transfers_recurring_frequency_weekly',
  transfers_recurring_execution_date_label:
    'transfers_recurring_execution_date_label',
  transfers_feedback_summary_recurring_execution_date:
    'transfers_feedback_summary_recurring_execution_date',
  transfers_feedback_summary_recurring_valid_until_date:
    'transfers_feedback_summary_recurring_valid_until_date',
  transfers_feedback_summary_recurring_repeat_until:
    'transfers_feedback_summary_recurring_repeat_until',
  transfers_feedback_recurring_success: 'transfers_feedback_recurring_success',
};

Object.freeze(translationKeys);

export default translationKeys;
